import { type UploadedImage } from '@/lib/types';
import StyledDialog from './StyledDialog';
import { useState } from 'react';
import PreviewDialogContent from './PreviewDialogContent';

type ImagePreviewDialogProps = {
  image: UploadedImage;
  showInappropriateContentIndicators: boolean;
  open: boolean;
  onClose: () => void;
};

const ImagePreviewDialog = ({
  image,
  open,
  showInappropriateContentIndicators,
  onClose,
}: ImagePreviewDialogProps) => {
  const [
    isShowingInappropriateContentOverlay,
    setIsShowingInappropriateContentOverlay,
  ] = useState(true);

  const closeDialog = (): void => {
    onClose();

    // Wait for the dialog animation to finish before showing overlay again.
    // This prevents the overlay from flashing back in while the dialog is
    // closing.
    setTimeout(() => {
      setIsShowingInappropriateContentOverlay(true);
    }, 250);
  };

  return (
    <StyledDialog open={open} onClose={closeDialog}>
      <PreviewDialogContent
        image={image}
        showInappropriateContentIndicators={showInappropriateContentIndicators}
        isShowingInappropriateContentOverlay={
          isShowingInappropriateContentOverlay
        }
        setIsShowingInappropriateContentOverlay={
          setIsShowingInappropriateContentOverlay
        }
        open={open}
        onClose={closeDialog}
      />
    </StyledDialog>
  );
};

export default ImagePreviewDialog;
